import styled from 'styled-components'
import theme from '../../styles/theme.css'

export const ContainerNote = styled.div`
    max-width: 680px;
    width: 90%;
    margin: 1.5rem auto;
    text-align: center;
    font-size: 1rem;
    div{
        max-width: 100%;
        height: 1px;
        background-color: #000;
        margin: 1rem 0;
    }
    p{
        padding: 1.5rem 2.5rem;
        font-family: ${theme.plexMono};
        line-height: 1.5rem;
        font-weight: 600;
    }
    span{
        font-size: 0.7rem;
        font-weight: 800;
        display: block;
        margin-bottom: 2rem; 
        font-family: ${theme.plexMono};
    }
`